import Stripe from "stripe";
export const stripeHolder = Stripe(process.env.REACT_APP_STRIPE_KEY);
